import { IPageName } from '../../common/types/apiSchema';
import { PathMap } from './paths';

/**
 * Localised URLs for Sweeden
 */
export const SvPaths: PathMap = {
  [IPageName.collections]: ['/:filterslug/filter'],
  [IPageName.bookingsPage]: ['/bokningar'],
  [IPageName.bookingDetailsPage]: ['/bokningar/:bookingId/details'],
  [IPageName.cancellationPage]: ['/bokningar/:bookingId/cancellation'],
};
